import React from "react";
import MCU from '../images/К1921ВК01Т2.jpg';
import LDO from '../images/КФ1158ЕН.jpg';
import GNSS from '../images/ПР1803Н.jpg';
const MadeOf = () => {
    return(
        <>  
            <div className="">
                <h2 className="uppercase font-medium w-full
                xl:text-4xl xl:pb-12
                lg:text-4xl lg:pb-12
                md:text-3xl md:pb-10
                sm:text-[28px] sm:pb-4 ">Основан на российсиких компонентах</h2>
                <div className="justify-center items-center
                xl:grid xl:grid-cols-[32%_32%_32%] xl:gap-[2%]
                lg:grid lg:grid-cols-[32%_32%_32%] lg:gap-[2%]
                md:grid md:grid-cols-[45%_45%] md:grid-rows-[50%_50%] md:gap-3
                sm:flex sm:flex-col sm:gap-5">
                    <div className="bg-[#EFEFEF] max-w-[90%] h-full">
                        <div className="pb-10 pt-5 px-5 flex flex-col">
                            <img src={MCU} alt="К1921ВК01Т2"/>
                            <h3 className="py-4 font-bold text-xl text-[#304DB6]">К1921ВК01Т2</h3>
                            <div className="max-w-90%">
                                <p>(г.Воронеж)</p>
                                <br/>
                                <p>Микроконтроллер на основе ядра ARM CORTEX-M4,       
                                    такой же использует Алмаз-Антей в своих
                                    устройствах</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-[#EFEFEF] max-w-[90%] h-full">
                        <div className="pb-10 pt-5 px-5 flex flex-col">
                            <img src={LDO} alt="КФ1158ЕН"/>
                            <h3 className="py-4 font-bold text-xl text-[#304DB6]">КФ1158ЕН</h3>
                            <div className="max-w-90%">
                                <p>(г. Брянск)</p>
                                <br/>
                                <p>Стабилизатор напряжения, обеспечивает питание микроконтроллера и датчиков,
                                    имеет встроенную защиту от перенапряжения и превышения тока</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-[#EFEFEF] max-w-[90%] h-full">
                        <div className="pb-10 pt-5 px-5 flex flex-col">
                            <img src={GNSS} alt="ПР1803Н"/>
                            <h3 className="py-4 font-bold text-xl text-[#304DB6]">ПР1803Н</h3>
                            <div className="max-w-90%">
                                <p>(г. Москва)</p>
                                
                                <p>Модуль навигации и связи содержит в себе все необходимое для автономного полета БПЛА</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MadeOf;
